/**
 * The `settings=` tokens Olympus' three provider callbacks emit. Each is
 * verbatim the operator settings route key in both Hermes and Hestia, so the
 * native mapping is a lookup rather than a translation table.
 */
export const MARKETPLACE_ONBOARDING_SETTINGS = [
    'brand.marketplaces.doordash',
    'brand.marketplaces.grubhub',
    'brand.marketplaces.ubereats',
];
/**
 * The query param each provider callback appends its own error code to. These
 * are load-bearing wire names written by Olympus' `buildRedirectUrl` in
 * `marketplace/v1/{doordash,ubereats}/callback.endpoint.ts` and
 * `services/marketplace/modules/oauth/providers/grubhub/callback.ts`; a client
 * reads the code back under exactly these keys.
 *
 * Kept out of `marketplace-onboarding.ts` so the package root can export it by
 * name. Reaching it through that module means three chained `export *` hops,
 * and Metro leaves such a binding undefined in the app bundle.
 */
export const MARKETPLACE_ONBOARDING_ERROR_PARAMS = {
    'brand.marketplaces.doordash': 'doordash_error',
    'brand.marketplaces.grubhub': 'grubhub_error',
    'brand.marketplaces.ubereats': 'ubereats_error',
};
//# sourceMappingURL=marketplace-onboarding-params.js.map